<template>
  <div>
    <span v-if="!edit">
      <span>{{ localValue instanceof Date && !isNaN(localValue) ? localValue.toLocaleDateString() : localValue}}</span>
      <a href="" @click.prevent="edit = true" v-if="!editNotAllowed">
        <b-icon icon="pencil" size="is-small" type="is-primary"/>
      </a>
    </span>
    <span v-if="edit">
      <b-field>
        <b-datepicker v-if="type === 'date'"
          placeholder="Click to select..."
          icon="calendar-today"
          v-model="localValue"
          v-focus
        />
        <b-input
          v-else
          :type="type"
          v-model="localValue"
          v-focus
          @keyup.native.enter="updateValue"
          />
      </b-field>
      <div class="buttons">
        <button class="button is-primary" @click.prevent="updateValue">
          Save
        </button>
        <button class="button is-danger" @click.prevent="edit = false">
          Cancel
        </button>
      <!-- <a href="" >Save</a>
      <a href="" @click.prevent="edit = false">Cancel</a> -->
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'FcfField',
  props: ['name', 'value', 'type', 'editNotAllowed'],
  data () {
    return {
      edit: false,
      localValue: this.value
    }
  },
  watch: {
    value () {
      this.localValue = this.value
    }
  },
  methods: {
    updateValue () {
      if (this.value !== this.localValue) {
        this.$emit('value-changed', { name: this.name, value: this.localValue })
      }
      this.edit = false
    }
  }
}
</script>

<style scoped>

</style>
